/**
 * Compile-time Better Auth feature gate.
 *
 * Keep this module dependency-free. AuthContext imports it statically so Vite
 * can fold disabled branches away; vite.config resolves the separate transport
 * facade to either the real client or a dependency-free flag-off stub.
 */
export const betterAuthEnabled = import.meta.env.VITE_AUTH_BETTER_AUTH_ENABLED === 'true'
